module.exports = {
  en: {
    'HRES85UC1': {
      '0': '[HRES85U] Approve of Travel Request',
      '10': '[HRES85U] Approve of Travel Request',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Req. Date',
      '55': 'No.',
      '60': 'Location',
      '70': 'Request Date',
      '80': 'Amount',
      '90': 'Purpose Of Travel',
      '100': 'Current Status ',
      '110': 'Approve By',
      '120': 'Appr. Date',
      '130': 'Remark',
      '140': 'Next Approve'
    },
    'HRES85UC2': {
      '0': 'Details of Approve',
      '10': 'For Employee',
      '20': 'Sequence No.',
      '30': 'Approve By',
      '40': 'Approve Date',
      '50': 'Approved Amount',
      '60': 'Baht',
      '70': 'Type Of Payment',
      '80': 'Cash',
      '90': 'Via Payroll',
      '100': 'Pay Date',
      '110': 'Period /m/y',
      '120': 'Pay Code',
      '130': 'Current Status',
      '140': 'Staus',
      '150': 'Approve',
      '160': 'Reject',
      '170': 'Remark'
    },
    'HRES85UC3': {
      '0': 'Details of Travel Request',
      '10': 'Details of Travel Request',
      '20': 'Request Date',
      '30': 'Location',
      '40': 'Country',
      '50': 'Distance',
      '60': 'km.',
      '70': 'Payment Rate',
      '80': 'Baht/km.',
      '90': 'Purpose Of Travel',
      '100': 'Working Date',
      '110': 'From Date',
      '120': 'Start Time',
      '130': 'To Date',
      '140': 'End Time',
      '150': 'No.Of Day',
      '160': 'Day',
      '170': 'Payment Rate',
      '180': 'Baht',
      '190': 'Or',
      '200': 'B/Day.',
      '210': 'Reference DOc.',
      '220': 'Attach File 1.',
      '230': 'Attach File 2.',
      '240': 'Attach File 3.',
      '250': 'Detail of Document'
    },
    'HRES85UC4': {
      '0': 'List of Income/Deduct Code',
      '10': 'List of Income/Deduct Code',
      '20': 'Pay Code',
      '30': 'Description'
    },
    'HRES85UC5': {
      '0': 'List of Payment code',
      '10': 'List of Payment code',
      '20': 'Code',
      '30': 'Description',
      '40': 'Code',
      '50': 'Description',
      '60': 'Num Page '
    },
    'HRES85UC6': {
      '0': 'List of Cost Travel',
      '10': 'List of Cost Travel',
      '20': 'List of Cost Code',
      '30': 'Code',
      '40': 'Description',
      '50': 'Amount',
      '60': 'Total Amount'
    }
  },
  th: {
    'HRES85UC1': {
      '0': '[HRES85U] อนุมัติการเบิกค่าเดินทาง',
      '10': '[HRES85U] อนุมัติการเบิกค่าเดินทาง',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่บันทึก',
      '55': 'ลำดับที่',
      '60': 'สถานที่',
      '70': 'ช่วงวันที่ขอเบิก',
      '80': 'จำนวนเงิน',
      '90': 'วัตถุประสงค์',
      '100': 'สถานะปัจจุบัน',
      '110': 'ผู้อนุมัติ',
      '120': 'วันที่อนุมัติ',
      '130': 'หมายเหตุการอนุมัติ',
      '140': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES85UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'อนุมัติโดย',
      '40': 'วันที่อนุมัติ',
      '50': 'ค่าใช้จ่ายที่อนุมัติ',
      '60': 'บาท',
      '70': 'ประเภทการจ่าย',
      '80': 'เงินสด',
      '90': 'ผ่านระบบเงินเดือน',
      '100': 'วันที่จ่าย',
      '110': 'งวด/เดือน/ปีที่จ่าย',
      '120': 'รหัสเงินได้',
      '130': 'สถานะปัจจุบัน',
      '140': 'สถานะ',
      '150': 'อนุมัติ',
      '160': 'ไม่อนุมัติ',
      '170': 'หมายเหตุ'
    },
    'HRES85UC3': {
      '0': 'รายละเอียดการเบิกเดินทาง',
      '10': 'รายละเอียดการเบิกเดินทาง',
      '20': 'วันที่บันทึก',
      '30': 'สถานที่',
      '40': 'ประเทศ',
      '50': 'ระยะทาง',
      '60': 'km.',
      '70': 'ค่าใช้จ่าย',
      '80': 'บาท/km.',
      '90': 'วัตถุประสงค์',
      '100': 'วันที่ปฏิบัติงานนอกบริษัท',
      '110': 'ตั้งแต่วันที่',
      '120': 'เวลาเริ่มต้น',
      '130': 'ถึงวันที่',
      '140': 'เวลาสิ้นสุด',
      '150': 'รวมจำนวนวัน',
      '160': 'วัน',
      '170': 'ค่าใช้จ่าย',
      '180': 'บาท',
      '190': 'หรือ',
      '200': 'บาท/วัน',
      '210': 'เอกสารเพิ่มเติม',
      '220': 'เอกสารที่ 1.',
      '230': 'เอกสารที่ 2.',
      '240': 'เอกสารที่ 3.',
      '250': 'รายละเอียดเอกสาร'
    },
    'HRES85UC4': {
      '0': 'รายการรหัสเงินได้/ส่วนหัก',
      '10': 'รายการรหัสเงินได้/ส่วนหัก',
      '20': 'รหัสเงินได้/ส่วนหัก',
      '30': 'รายละเอียด'
    },
    'HRES85UC5': {
      '0': 'List of Payment code',
      '10': 'List of Payment code',
      '20': 'รหัส',
      '30': 'รายละเอียด',
      '40': 'รหัส',
      '50': 'รายละเอียด',
      '60': 'จำนวนหน้า'
    },
    'HRES85UC6': {
      '0': 'รายละเอียดค่าใช้จ่ายในการเดินทาง',
      '10': 'รายละเอียดค่าใช้จ่ายในการเดินทาง',
      '20': 'รายะละเอียดรหัสค่าใช้จ่าย',
      '30': 'รหัส',
      '40': 'รายละเอียด',
      '50': 'จำนวนเงินที่ขอเบิก',
      '60': 'จำนวนเงินรวม'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres85u.js